import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  btnTextShow: string = 'Read More';
  btnTextHide: string = 'Read Less';
  btnText: string = this.btnTextShow;
  constructor() { }

  ngOnInit() {
  }
  readContent(): void {
    if (this.btnText === this.btnTextShow) {
      this.btnText = this.btnTextHide;
    }
    else {
      this.btnText = this.btnTextShow;
    }
  }

}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/footer/footer.component.ts